import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';

import {
  FeaturesDetailsOverlayTypeEnum,
  SingleRoomControlOverlayTypeEnum,
} from '../../../+installations/installation/installation-overlay.model';
import { InstallationService } from '../../../+installations/services/installation.service';
import { UIService } from '../../services/ui.service';
import { FeaturePropertyKey, PowerLimitationTooltip } from '@vi-iot/client/index';
import { PillType } from '../pill/pill.model';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-features-container',
  templateUrl: './features-container.component.html',
  styleUrls: ['./features-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturesContainerComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  @Input() header: string;
  @Input() actionButtonName: string;
  @Input() overlayType: FeaturesDetailsOverlayTypeEnum;
  @Input() srcOverlayType: SingleRoomControlOverlayTypeEnum;
  @Input() heatingCircuitId?: string;
  @Input() refrigerantCircuitId?: string;
  @Input() isMoreActions = false;
  @Input() powerLimitationLabel: PowerLimitationTooltip[];
  parentComponentSelector: string;
  readonly featurePropertyKey = FeaturePropertyKey;
  readonly pillType = PillType;
  constructor(
    private uiService: UIService,
    private elRef: ElementRef,
    protected installationService: InstallationService
  ) {}

  ngOnInit(): void {
    this.parentComponentSelector = this.elRef.nativeElement.parentElement.tagName.toLowerCase();
  }

  onDetails(): void {
    this.openOverlay(this.overlayType);
  }

  protected openOverlay(overlayType: FeaturesDetailsOverlayTypeEnum): void {
    if (this.heatingCircuitId) {
      this.installationService.selectedCircuitId$.next(this.heatingCircuitId);
    }
    if (this.refrigerantCircuitId) {
      this.installationService.selectedRefrigerantCircuitId$.next(this.refrigerantCircuitId);
    }

    if (this.srcOverlayType) {
      this.uiService.openSingleRoomControlOverlay(this.srcOverlayType);
    } else {
      this.uiService.openActiveOverlay(overlayType);
    }
  }
}
